'use client';

import { useEffect, useState, type RefObject } from 'react';
import { createPortal } from 'react-dom';

import HeaderDropdownSurface from './HeaderDropdownSurface';
import HeaderMegaMenuCategories from './HeaderMegaMenuCategories';
import HeaderMegaMenuPanel from './HeaderMegaMenuPanel';
import HeaderSimpleDropdownList from './HeaderSimpleDropdownList';
import type { DropdownPosition } from '../../types/header';
import useHeaderMegaMenu from '../../hooks/header/useHeaderMegaMenu';
import type { NavDropdownItem, NavMegaMenu } from '../../types/navigation';

export const SimpleDropdown = ({
  dropdownRef,
  items,
  onMouseEnter,
  onMouseLeave,
  position,
}: {
  dropdownRef: RefObject<HTMLDivElement | null>;
  items: NavDropdownItem[];
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  position: DropdownPosition;
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return createPortal(
    <HeaderDropdownSurface
      dropdownRef={dropdownRef}
      position={position}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <HeaderSimpleDropdownList items={items} />
    </HeaderDropdownSurface>,
    document.body,
  );
};

export const MegaMenuDropdown = ({
  dropdownRef,
  megaMenu,
  onMouseEnter,
  onMouseLeave,
  position,
}: {
  dropdownRef: RefObject<HTMLDivElement | null>;
  megaMenu: NavMegaMenu;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  position: DropdownPosition;
}) => {
  const { activeGroup, activeGroupId, setActiveGroupId } = useHeaderMegaMenu(megaMenu);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return createPortal(
    <HeaderDropdownSurface
      aria-label="Panel Descubre ADIPA"
      className="global-header-mega-surface"
      dropdownRef={dropdownRef}
      position={position}
      variant="section"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="mega-menu-grid">
        <HeaderMegaMenuCategories
          activeGroupId={activeGroupId}
          categories={megaMenu.categories}
          groups={megaMenu.groups}
          onGroupChange={setActiveGroupId}
        />

        <HeaderMegaMenuPanel activeGroup={activeGroup} />
      </div>
    </HeaderDropdownSurface>,
    document.body,
  );
};
